var ReactFormControlViews = require('./reactformcontrolviews')
var ReactFormContainerViews = require('./reactformcontainerviews');

var SaleQuestionnaireProvider = {
    getEmailInputView: () => {
        return ReactFormControlViews.EmailInputView;
    },

    getDateCombosView: () => {
        return ReactFormControlViews.DateCombosView;
    },

    getRadioButtonView: () => {
        return ReactFormControlViews.RadioButtonView;
    },

    getCheckboxView: () => {
        return ReactFormControlViews.CheckboxView;
    },

    getCheckboxWithTextInputView: () => {
        return ReactFormControlViews.CheckboxWithTextInputView;
    },
    
    getDropdownView: () => {
        return ReactFormControlViews.DropdownView;
    },

    getSimpleTextFieldView: () => {
        return ReactFormControlViews.SimpleTextFieldView;
    },
    
    getMultilineView: () => {
        return ReactFormControlViews.MultilineView;
    },

    getMultipleItemsView: () => {
        return ReactFormControlViews.MultipleItemsView;
    },

    getMultipleDocumentsView: () => {
        return ReactFormControlViews.MultipleDocumentsView;
    },

    getFormContainerView: () => {
        return ReactFormContainerViews.FormContainerView;
    },

    getFormChildrenView: () => {
        return ReactFormContainerViews.FormChildrenView;
    },
    
    getFormFieldListView: () => {
        return ReactFormContainerViews.FormFieldListView;
    },

    getFormGroupWrapperView: () => {
        return ReactFormContainerViews.FormGroupWrapperView;
    }
}

export default SaleQuestionnaireProvider;
